import clsx from 'clsx';
import styles from './DialogPopup.module.scss';
import React from 'react';
import { useDialogContext } from '../DialogContext.ts';
export const DIALOG_POPUP_SIZES = [
    'sm',
    'md',
    'lg'
];
export function DialogPopup({ children }) {
    const { size } = useDialogContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.popup, {
            [styles.compact]: size == 'compact',
            [styles.sm]: size == 'sm',
            [styles.md]: size == 'md',
            [styles.lg]: size == 'lg'
        }),
        "data-testid": "dialog-popup"
    }, children);
}
